import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { send } from "../utils/sockets/asyncSocket";
import config from "../components/helpers/socket/config";
import { pubsubEvents } from "../components/helpers/socket/pubsubEvent";
import CMEDLoginScreen from "../platforms/cmed/CMEDLoginScreen/CMEDLoginScreen";
import { createPayload } from "../utils/sockets/payload";

type CMEDProfilesPageProps = {};

const CMEDProfilesPage: React.FC<CMEDProfilesPageProps> = ({}) => {
  const [userProfiles, setUserProfiles] = useState<any[]>([]);
  const [singleProfile, setsingleProfile] = useState<any[]>([]);

  const [singleFlag, setsingleFlag] = useState<boolean>(true);

  useEffect(() => {
    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_POST_LOGIN_USER_ACCOUNTS,
      setUserProfileData,
    );

    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_SUCCESS,
      getLogonResponse,
    );

    let request = {
      action: config.socket.actions.CMED_TRADING_ACCOUNTS,
      requestID: uuidv4(),
      type: "loadTradingAccountsRequest",
      payload: {},
    };
    send(config.socket.channels.TRADING, request);
  }, []);

  const setUserProfileData = (msg: any, data: any) => {
    if (data.payload === null) {
      setsingleFlag(true);
      send(
        config.socket.channels.TRADING,
        createPayload(config.socket.actions.CMED_LOGON, "loginRequest", {}),
      );
    } else {
      if (Array.isArray(data.payload)) {
        setsingleFlag(false);
        setUserProfiles(data.payload);
      }
    }
  };

  const getLogonResponse = (msg: any, data: any) => {
    const loginSelection = data?.payload?.loginSelection;
    // Ensure loginSelection is a non-array object before setting state
    if (
      loginSelection &&
      typeof loginSelection === "object" &&
      userProfiles.length === 0
    ) {
      setsingleProfile([loginSelection]);
    }
  };

  return (
    <CMEDLoginScreen
      userAccountData={!singleFlag ? userProfiles : singleProfile[0]}
      mapUserNameToIdAndSelect={() => {}}
      isCMEDLoggedIn={true}
      loginFaild={[]}
      viewOnly={true}
      singleFlag={singleFlag}
    />
  );
};

export default CMEDProfilesPage;
